import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=526778a0&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=526778a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports